import styled from 'styled-components';

export const Em = styled.span`
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./components/Em/Em.js